import { trackPageLoad } from "@asosteam/asos-content-web-analytics";
import sdkProvider from "./sdk-provider";
import analyticsProvider from "./analyticsProvider";
import getUserLoginStatus from "./getUserLoginStatus";

export const trackPageEvent = async () => {
  try {
    const identity = await sdkProvider("identity");
    const isAuthenticated = await identity.customer.isAuthenticated();
    const isRecognised = (await identity.customer.isRecognised?.()) || false;
    const customerId = await identity.customer.customerId();
    const { platform = "", storeId = "" } =
      window.asos.webContext.getWebContext();
    const server = `${platform} ${storeId.toLowerCase()}`;
    const pageLoadProperties = {
      server,
      customerId,
      loginStatus: getUserLoginStatus({ isAuthenticated, isRecognised }),
    };
    const config = analyticsProvider("page-load", pageLoadProperties);
    await trackPageLoad(config);
  } catch (e) {
    throw new Error(`Error tracking page event: ${e.message}`);
  }
};
